import React, { useEffect, useState } from "react";
import { useCookies } from 'react-cookie';
import { Link, useNavigate } from 'react-router-dom';

const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #0b0f14, #0a0a0c)",
    color: "#e7e7e9",
    padding: "48px 16px 72px",
    fontFamily: "'Pretendard', 'Noto Sans KR', system-ui, -apple-system, sans-serif",
    boxSizing: "border-box",
  },
  container: {
    maxWidth: "980px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: "18px",
  },
  card: {
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.07)",
    boxShadow: "0 20px 40px rgba(0,0,0,0.32)",
    borderRadius: "18px",
    padding: "20px 20px",
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
  },
  title: {
    margin: 0,
    fontSize: "26px",
    fontWeight: 800,
    color: "#fff",
    letterSpacing: "-0.02em",
  },
  helper: {
    color: "#cbd5e1",
    fontSize: "13px",
    lineHeight: 1.5,
  },
  userInfo: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    marginTop: "8px",
  },
  tag: {
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: "10px",
    padding: "10px 12px",
    fontWeight: 700,
    color: "#f8fafc",
  },
  actionsRow: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    marginTop: "10px",
  },
  buttonPrimary: {
    padding: "12px 14px",
    borderRadius: "12px",
    border: "1px solid rgba(255,255,255,0.12)",
    background: "linear-gradient(120deg, #fb923c, #f97316)",
    color: "#130903",
    fontWeight: 800,
    cursor: "pointer",
    boxShadow: "0 12px 28px rgba(249,115,22,0.26)",
  },
  buttonGhost: {
    padding: "12px 14px",
    borderRadius: "12px",
    border: "1px solid rgba(255,255,255,0.12)",
    background: "rgba(255,255,255,0.05)",
    color: "#f8fafc",
    fontWeight: 700,
    cursor: "pointer",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
    gap: "14px",
  },
  tile: {
    background: "rgba(255,255,255,0.03)",
    border: "1px solid rgba(255,255,255,0.07)",
    borderRadius: "14px",
    padding: "18px",
    boxShadow: "0 16px 32px rgba(0,0,0,0.28)",
  },
  tileDisabled: {
    opacity: 0.55,
    filter: "grayscale(14%)",
    background: "rgba(255,255,255,0.02)",
    borderStyle: "dashed",
  },
  tileTitle: {
    margin: "0 0 8px",
    color: "#f8fafc",
    fontWeight: 800,
    fontSize: "17px",
  },
  tileDesc: {
    color: "#cbd5e1",
    fontSize: "13px",
    lineHeight: 1.5,
    marginBottom: "12px",
  },
  badgeComing: {
    display: "inline-block",
    padding: "4px 10px",
    borderRadius: "999px",
    background: "rgba(255,255,255,0.08)",
    color: "#94a3b8",
    fontWeight: 700,
    fontSize: "11px",
    marginBottom: "8px",
    border: "1px solid rgba(255,255,255,0.12)",
  },
  buttonDisabled: {
    pointerEvents: "none",
    opacity: 0.55,
    cursor: "not-allowed",
  },
  popupOverlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.65)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2000,
    padding: "16px",
  },
  popupBox: {
    background: "rgba(15,15,20,0.95)",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: "16px",
    padding: "20px 18px",
    width: "100%",
    maxWidth: "420px",
    boxShadow: "0 20px 48px rgba(0,0,0,0.45)",
  },
  popupTitle: {
    margin: "0 0 10px",
    color: "#fff",
    fontSize: "20px",
    fontWeight: 800,
  },
  popupField: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    marginBottom: "12px",
  },
  popupLabel: {
    color: "#f8fafc",
    fontWeight: 700,
    fontSize: "14px",
  },
  popupInput: {
    width: "100%",
    padding: "12px 14px",
    borderRadius: "12px",
    border: "1px solid rgba(255,255,255,0.14)",
    background: "rgba(15,15,20,0.85)",
    color: "#f8fafc",
    fontSize: "15px",
    boxSizing: "border-box",
  },
  popupActions: {
    display: "flex",
    gap: "10px",
    justifyContent: "flex-end",
    marginTop: "6px",
  },
  popupBtnPrimary: {
    padding: "10px 14px",
    borderRadius: "12px",
    border: "1px solid rgba(255,255,255,0.12)",
    background: "linear-gradient(120deg, #fb923c, #f97316)",
    color: "#130903",
    fontWeight: 800,
    cursor: "pointer",
    boxShadow: "0 12px 28px rgba(249,115,22,0.26)",
  },
  popupBtnGhost: {
    padding: "10px 14px",
    borderRadius: "12px",
    border: "1px solid rgba(255,255,255,0.12)",
    background: "rgba(255,255,255,0.05)",
    color: "#f8fafc",
    fontWeight: 700,
    cursor: "pointer",
  },
  popupMessage: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    background: "rgba(15,10,8,0.9)",
    color: "#f8fafc",
    padding: "12px 14px",
    borderRadius: "12px",
    border: "1px solid rgba(255,255,255,0.12)",
    boxShadow: "0 16px 32px rgba(0,0,0,0.35)",
    maxWidth: "280px",
    zIndex: 1500,
    fontSize: "14px",
  },
};

const autofillStyles = `
.select-input {
  background: rgba(15,15,20,0.9) !important;
  color: #f8fafc !important;
  border: 1px solid rgba(255,255,255,0.14) !important;
  border-radius: 12px;
  padding: 12px 14px;
  box-sizing: border-box;
}
.select-input::placeholder {
  color: #94a3b8;
}
.select-input:focus {
  outline: 2px solid rgba(249,115,22,0.45) !important;
  border-color: rgba(249,115,22,0.45) !important;
  box-shadow: 0 0 0 1000px rgba(15,15,20,0.95) inset !important;
}
.select-input:-webkit-autofill,
.select-input:-webkit-autofill:hover,
.select-input:-webkit-autofill:focus,
.select-input:-webkit-autofill:active {
  background: rgba(15,15,20,0.95) !important;
  -webkit-text-fill-color: #f8fafc !important;
  box-shadow: 0 0 0 1000px rgba(15,15,20,0.95) inset !important;
  caret-color: #f8fafc;
  border: 1px solid rgba(255,255,255,0.14) !important;
}
`;


export default function SelectPage(){

    const [cookies] = useCookies(['uuid']);

    // 쿠키에서 UUID를 이용하여 사용자 정보 가져오기
    const[uid,setUID] = useState(0);
    const[nickname,setNickname] = useState('');
    const[email,setEmail] = useState('');
    const[grade,setGrade] = useState('');
    const[ex_period,setExperiod] = useState('');
  
    const [showMessage, setShowMessage] = useState(false);
    const [confirmMessage, setConfirmMessage] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
      if (!cookies.uuid) {
        alert('로그인 정보가 존재하지 않습니다. 로그인 페이지로 이동합니다.');
        window.location.href = `/LoginAts`;
        return;
      } else {
        const uuid = cookies.uuid;
        fetchUserInfo(uuid);
      }
    }, []);

    useEffect(() => {
      // 여기에 통신 요청이 완료되면 알림 메시지를 자동으로 사라지게 하는 로직을 추가하세요.
      const timer = setTimeout(() => {
        setShowMessage(false);
      }, 3000); // 5초 후에 알림 메시지를 숨김
      return () => clearTimeout(timer); // 컴포넌트가 언마운트되면 타이머 해제
    }, [showMessage]); 

    useEffect(() => {
      console.log('클라이언트 uuid', cookies.uuid);
    }, [cookies.uuid]);
  
    const fetchUserInfo = (uuid) => {
      fetch(`/SetPage/user?uuid=${uuid}`)
        .then(response => {
          if (!response.ok) {
            throw new Error('서버 응답 실패');
          }
          return response.json();
        })
        .then(data => {
          const user = data[0];
          setUID(user.uid);
          setGrade(user.grade);
          setExperiod(user.ex_period);
          setNickname(user.nickname);
          setEmail(String(user.email ?? ''));
        })
        .catch(error => {
          alert('로그인 정보가 존재하지 않습니다. 로그인 페이지로 이동합니다.');
          window.location.href = `/LoginAts`;
          return;
        });
    };
    
    console.log(uid);

    // Check period
    const onCheck_period = () => {
        fetch(`/check_period?uid=${uid}`)
        .then((response) => {
        if(!response.ok) {
            throw new Error('400 아니면 500 에러남');
        }
        return response.json()
        })
        .then((result) => {
          alert(`${result.msg}`);
          window.location.reload();
        })
        .catch((error) => {
        console.log('에러남',error);
        })
    };

    // Web version select
    const onWeb_version = () => {
    setConfirmMessage(`거래소와 통신중입니다. 잠시만 기다리세요!`);
    setShowMessage(true);

    fetch(`/webversion_selected?uid=${uid}`)
    .then(async (response) => {
        setShowMessage(false);
        if (!response.ok) {
            // 서버에서 보내는 텍스트 메시지 받기
            const errorMsg = await response.text();
            throw new Error(errorMsg);
        }
        // 정상 응답은 JSON
        return response.json();
    })
    .then((result) => {
        console.log('onweb_DB에서 받아온 데이터', result);
        window.location.href = `/SinglePage`;
    })
    .catch((error) => {
        console.log('에러남', error);
        setConfirmMessage(error.message); // 에러 메시지 사용자에게 표시
        setShowMessage(true);
    });
  };

  // Track version select
  const onTrack_version = () => {
    setConfirmMessage(`거래소와 통신중입니다. 잠시만 기다리세요!`);
    setShowMessage(true);

    fetch(`/trackversion_selected?uid=${uid}`)
    .then(async (response) => {
        setShowMessage(false);
        if (!response.ok) {
            // 서버에서 보내는 텍스트 메시지 받기
            const errorMsg = await response.text();
            throw new Error(errorMsg);
        }
        // 정상 응답은 JSON
        return response.json();
    })
    .then((result) => {
        console.log('ontrack_DB에서 받아온 데이터', result);
        window.location.href = `/SinglePageTrack`;
    })
    .catch((error) => {
        console.log('에러남', error);
        setConfirmMessage(error.message); // 에러 메시지 사용자에게 표시
        setShowMessage(true);
    });
  };

  const handlePayment = () => {
    alert("USDT 입금시엔 꼭 본인계정에서 입금 해주세요! 타인의 계정으로 입금시 결제정보가 반영되지 않습니다.");
    navigate("/PaymentPage");
  };

    return (
      <>
        <style dangerouslySetInnerHTML={{ __html: autofillStyles }} />
        <div style={styles.page}>
          <div style={styles.container}>
            <Link to="/AdminPage" className="hidden-top-right-button" />
            <div style={styles.headerRow}>
              <h1 style={styles.title}>Speed BOT 선택 페이지</h1>
            </div>
            <p style={styles.helper}>서비스를 선택하고 결제/기간 확인, Web 버전을 시작하세요.</p>

            <div style={styles.card}>
              <div style={styles.userInfo}>
                <span style={styles.tag}>UID : {uid}</span>
                <span style={styles.tag}>{nickname}님 환영합니다</span>
                <span style={styles.tag}>{email || "-"}</span>
                <span style={styles.tag}>등급: {grade || "-"}</span>
                <span style={styles.tag}>사용기한: {ex_period || "-"}</span>
              </div>
              <div style={styles.actionsRow}>
                <button
                  onClick={handlePayment}
                  style={styles.buttonPrimary}
                >
                  결제하기 💳
                </button>
                <button
                  onClick={() => onCheck_period()}
                  style={styles.buttonGhost}
                >
                  결제 후 확인
                </button>
              </div>
            </div>

            <div style={styles.grid}>
              <div style={styles.tile}>
                <h3 style={styles.tileTitle}>TRACK version</h3>
                <p style={styles.tileDesc}>BOT을 실행합니다.</p>
                <button
                  onClick={() => onTrack_version()}
                  style={styles.buttonPrimary}
                >
                  실행하기
                </button>
              </div>
            <div style={{ ...styles.tile, ...styles.tileDisabled }}>
              <span style={styles.badgeComing}>Coming Soon</span>
              <h3 style={styles.tileTitle}>WEB version</h3>
              <p style={styles.tileDesc}>BOT을 활용한 예측 자동 매매 (준비중)</p>
              <button
                disabled
                style={{ ...styles.buttonGhost, ...styles.buttonDisabled }}
              >
                준비중
              </button>
            </div>
            <div style={{ ...styles.tile, ...styles.tileDisabled }}>
              <span style={styles.badgeComing}>Coming Soon</span>
              <h3 style={styles.tileTitle}>Pro Signal</h3>
              <p style={styles.tileDesc}>고급 신호 분석 기반 자동 매매 (준비중).</p>
              <button
                disabled
                style={{ ...styles.buttonGhost, ...styles.buttonDisabled }}
              >
                준비중
              </button>
            </div>
            <div style={{ ...styles.tile, ...styles.tileDisabled }}>
              <span style={styles.badgeComing}>Coming Soon</span>
              <h3 style={styles.tileTitle}>Alpha Lab</h3>
              <p style={styles.tileDesc}>실험적 전략 테스트 공간 (준비중).</p>
              <button
                disabled
                style={{ ...styles.buttonGhost, ...styles.buttonDisabled }}
              >
                준비중
              </button>
            </div>
            </div>
          </div>

          {showMessage && (
            <div style={styles.popupMessage}>{confirmMessage}</div>
          )}
        </div>
      </>
    );
}
  